<template>
  <div class="app">
    <Sidebar v-if="showSidebar" />
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Sidebar from './components/Sidebar.vue';

export default defineComponent({
  name: 'app',
  components: {
    Sidebar
  },
  data() {
    return {
    }
  },
  computed: {
    showSidebar() {
      return this.$route.path !== '/';
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  },
});
</script>
<style lang="scss" scoped>
.app {
	display: flex;
	min-width: 1366px;
	min-height: 768px;
}

.main-content {
	flex: 1;
	min-height: 100vh;
	overflow-x: hidden;
}
</style>
